import { sharedService } from "@/modules/shared/store/services/shared-service";
import { RECEIVE_GET_COUNTRIES } from "@/redux/constants/parameters";

const getCountries = sharedService.injectEndpoints({
  endpoints: builder => ({
    getCountries: builder.query({
      query: () => "parameters/countries",
      transformResponse: response => response.items,
      providesTags: ["Countries"],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch({ type: RECEIVE_GET_COUNTRIES, countries: data });
        } catch { /* handled by RTK Query error state */ }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetCountriesQuery } = getCountries;


